import React, { Component, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { axiosPost } from "../../../utils/AxiosApi";
import {
	URL,
	checkWidgetAdminOrNot,
	draggable,
} from "../../../utils/Constants";
import "../../../assets/scss/academicYear.scss";
import Semester from "./Semester";
import CustomCollapse from "../../UI/CustomCollapse";
import Scroll from "react-scroll";
import ModalWindow from "./../../UI/ModalWindow";
import GranularPermissionModal from "./../../Permissions/GranularPermissionModal";
import { connect } from "react-redux";
import { getAcademicYears } from "../../../ducks/AcademicAdministrationDucks";
import {
	displaySuccessAlert,
	displayConfirmDeleteAlert,
	showErroMessage,
} from "../../../utils/Utils";
import { checkRolePermissions } from "../../../utils/Constants";
import AddTermsModal from "./AddTermsModal";
import swal from "sweetalert";
import moment from "moment";
import { Spinner } from "reactstrap";
const { adToBs, bsToAd } = require("@sbmdkl/nepali-date-converter");

const scroll = Scroll.animateScroll;

class AcademicYearsList extends Component {
	state = {
		termAlias:
			localStorage.getItem("educationLevelDivision") === null
				? "Term"
				: localStorage.getItem("educationLevelDivision"), //get from localStorage
		academicYearsList: [],
		updatedName: "",
		updatedStartDate: "",
		updatedEndDate: "",
		updatedId: "",
		updatedweekDays: [],
		weekDays: [],
		addTermModal: false,
		newTerms: [],
		selectedEducationLevel: "",
		selectedAcademicYear: "",
		minStartDate: "",
		showSpinner: false,
		maxEndDate: "",
	};

	toggleCollpasible = (e, id, idx) => {
		const academicYearsList = [...this.state.academicYearsList];
		for (const el of academicYearsList) {
			if (Number.parseInt(el.id) === Number.parseInt(id)) {
				el.isOpen = !el.isOpen;
			} else {
				el.isOpen = false;
			}
		}

		if (academicYearsList.length > 1) {
			const spliceArray = academicYearsList.splice(idx, 1);
			academicYearsList.unshift(spliceArray[0]);
		}
		this.setState({
			academicYearsList,
		});
	};
	componentDidMount() {
		this.getAcademicYears();
		this.getWeekDays();
	}

	getWeekDays = () => {
		axiosPost(URL.getWeekDays, {}, (response) => {
			if (response.status === 200) {
				const days = response.data.data;
				for (const week of days) {
					week.checked = false;
				}

				this.setState({ weekDays: days });
			}
		});
	};

	getAcademicYears = () => {
		axiosPost(URL.getAcademicYears, {}, (response) => {
			if (response.status === 200) {
				const academicYearsList = response.data.data;
				academicYearsList.forEach((el, idx) => {
					if (el.isCurrent) {
						el.isOpen = true;
					}
					else {
						el.isOpen = false;
					}
					el.realName = el.name;
					el.name = el.name.replace(/_/g, "-");
				});

				this.setState(
					{
						academicYearsList,
					},
					() => {
						const academicYearsList = [...this.state.academicYearsList];
						for (const academicYear of academicYearsList) {
							if (academicYear?.educationLevels) {
								for (const educationLevel of academicYear.educationLevels) {
									for (const educationLevelDivision of educationLevel.educationLevelDivisions) {
										educationLevelDivision.isEditable = false;
									}
								}
							}
						}

						this.setState({ academicYearsList });
					},
				);
			}
		});
	};

	scrollToTop = () => {
		scroll.scrollToTop();
	};

	handleCurrentChange = (e, id, idx) => {
		const param = {
			id: id,
			isCurrent: true,
		};
		axiosPost(URL.updateAcademicYearsIsCurrent, param, (response) => {
			if (response.status === 200) {
				displaySuccessAlert(response);
				this.getDataAfterUpdate(id, idx);
			}
		});
	};

	getDataAfterUpdate = (id, idx) => {
		axiosPost(URL.getAcademicYears, {}, (response) => {
			if (response.status === 200) {
				const academicYearsList = response.data.data;
				for (const el of academicYearsList) {
					if (Number.parseInt(el.id) === Number.parseInt(id)) {
						el.isOpen = true;
					} else {
						el.isOpen = false;
					}
				}

				const spliceArray = academicYearsList.splice(idx, 1);
				academicYearsList.unshift(spliceArray[0]);
				this.setState({
					academicYearsList,
				});
			}
		});
	};

	handleEnabledClick = (e, id, idx, isEnabled) => {
		const param = {
			id: id,
			isEnabled: isEnabled,
		};

		axiosPost(URL.updateAcademicYearsIsEnabled, param, (response) => {
			if (response.status === 200) {
				displaySuccessAlert(response);
				this.getDataAfterUpdate(id, idx);
			}
		});
	};

	handleUpdate = (
		e,
		mainIndex,
		educationLevelIndex,
		educationLevelDivisionIndex,
	) => {
		const academicYearsList = [...this.state.academicYearsList];
		academicYearsList.forEach((academicYear, i) => {
			if (mainIndex === i) {
				academicYear.educationLevels.forEach((educationLevel, j) => {
					if (educationLevelIndex === j) {
						educationLevel.educationLevelDivisions.forEach(
							(educationLevelDivision, k) => {
								if (educationLevelDivisionIndex === k) {
									educationLevelDivision.isEditable = true;
									const weekDays = [...this.state.weekDays];
									for (const week of weekDays) {
										week.checked = false;
									}

									const updatedWeekDays = educationLevelDivision.weekDays;
									for (i = 0; i < weekDays.length; i++) {
										for (j = 0; j < updatedWeekDays.length; j++) {
											if (weekDays[i].id === updatedWeekDays[j].id) {
												weekDays[i].checked = true;
											}
										}
									}
									this.setState({
										updatedName: educationLevelDivision.name,
										updatedStartDate: educationLevelDivision.startDate,
										updatedEndDate: educationLevelDivision.endDate,
										updatedId: educationLevelDivision.id,
										weekDays,
									});
								} else {
									educationLevelDivision.isEditable = false;
								}
							},
						);
					} else {
						for (const eduDiv of educationLevel.educationLevelDivisions) {
							eduDiv.isEditable = false;
						}
					}
				});
			} else {
				for (const eduLevel of academicYear.educationLevels) {
					for (const eduDiv of eduLevel.educationLevelDivisions) {
						eduDiv.isEditable = false;
					}
				}
			}
		});
		this.setState({ academicYearsList });
	};

	handleChange = (e) => {
		const target = e.target;
		const value = target.value;
		const name = target.name;
		this.setState({
			[name]: value,
		});
	};

	handleChangeForCheckBox = (e, id) => {
		const weekDays = [...this.state.weekDays];
		weekDays.forEach((week, i) => {
			if (week.id === id) {
				week.checked = e.target.checked;
			}
		});
		this.setState({ weekDays });
	};
	handleCancelEdit = (e, mainIndex, eduLevelIdx, eduLevelDivIdx) => {
		e.preventDefault();
		const academicYearsList = [...this.state.academicYearsList];
		academicYearsList[mainIndex].educationLevels[
			eduLevelIdx
		].educationLevelDivisions[eduLevelDivIdx].isEditable = false;
		this.setState({ academicYearsList });
	};

	handleDelete = (id, academicYearId, academicYearIndex) => {
		displayConfirmDeleteAlert(
			{ id, academicYearId, academicYearIndex },
			this.handleRemoveEducationLevelDivision,
		);
	};
	handleRemoveEducationLevelDivision = (data) => {
		const param = {
			id: data.id,
			academicYearId: data.academicYearId,
		};
		axiosPost(URL.deleteEducationLevelDivision, param, (response) => {
			if (response.status === 200) {
				displaySuccessAlert(response);
				this.getDataAfterUpdate(data.academicYearId, data.academicYearIndex);
			} else {
				showErroMessage(response);
			}
		});
	};

	handleUpdateEducationLevelDivision = (
		e,
		id,
		academicYearId,
		academicYearIndex,
	) => {
		e.preventDefault();
		const weekDays = [...this.state.weekDays];
		const updatedWeekDays = [];
		for (const week of weekDays) {
			if (week.checked) {
				updatedWeekDays.push(week);
			}
		}

		const param = {
			id: id,
			name: this.state.updatedName,
			startDate: this.state.updatedStartDate,
			endDate: this.state.updatedEndDate,
			weekDays: updatedWeekDays,
			academicYearId: academicYearId,
		};
		axiosPost(
			URL.updateEducationLevelDivision,
			param,
			(response) => {
				if (response.status === 200) {
					displaySuccessAlert(response);
					this.getDataAfterUpdate(academicYearId, academicYearIndex);
				}
				// else {
				//   showErroMessage(response);
				// }
			},
			(error) => {
				if (
					error?.response?.data?.message ===
					"Could not be updated as this term is already runnning"
				) {
					swal({
						title: "Warning",
						text: error?.response?.data?.message,
						closeOnClickOutside: false,
						allowOutsideClick: false,
					});
				} else {
					swal({
						title: "Oops",
						text: error?.response?.data?.message,
						closeOnClickOutside: false,
						allowOutsideClick: false,
					});
				}
			},
		);
	};

	//Handle Add Terms
	handleAddTerms = (e, action, eduLevel, academicYear) => {
		let newTerms = [];
		if (action === "open") {
			newTerms = [
				{
					name: "",
					startDate: "",
					date_toggle: false,
					endDate: "",
					selectedWeekDays: JSON.parse(
						JSON.stringify([...this.state.weekDays]),
					),
				},
			];
			this.setState({
				selectedAcademicYear: academicYear.dbName,
				selectedEducationLevel: eduLevel,

				maxEndDate: moment(academicYear.endDate).format("YYYY-MM-DD"),
			});

			if (eduLevel.educationLevelDivisions.length > 0) {
				const lastElement =
					eduLevel.educationLevelDivisions[
					eduLevel.educationLevelDivisions.length - 1
					];
				this.setState({
					minStartDate: moment(lastElement.endDate).format("YYYY-MM-DD"),
				});
			} else {
				this.setState({
					minStartDate: moment(academicYear.startDate).format("YYYY-MM-DD"),
				});
			}
		} else {
			this.setState({
				selectedAcademicYear: "",
				selectedEducationLevel: "",
				minStartDate: "",
				maxEndDate: "",
			});
		}
		this.setState({
			addTermModal: !this.state.addTermModal,
			newTerms: newTerms,
		});
	};

	// handleTermDataChange = (e, idx) => {
	//   e.preventDefault();
	//   let newTerms = [...this.state.newTerms];

	//   if (e.target.name === "startDate" && idx !== newTerms.length - 1) {
	//     newTerms.forEach((nt) => {
	//       newTerms[idx].endDate = "";
	//       newTerms[idx + 1].startDate = "";
	//       newTerms[idx + 1].endDate = "";
	//     });

	//     newTerms[idx].startDate = e.target.value;
	//     this.setState({ newTerms });
	//   }
	//   // else if (e.target.name === "startDate") {
	//   //   newTerms[idx][e.target.name] = e.target.value;

	//   //   newTerms[idx].endDate = "";
	//   //   this.setState({ newTerms });
	//   // }
	//   else {
	//     newTerms[idx][e.target.name] = e.target.value;
	//     this.setState({ newTerms });
	//   }
	// };

	handleTermDataChange = (name, value, idx) => {
debugger
		const newTerms = [...this.state.newTerms];

		if (name === "startDate") {
			newTerms[idx].startDate = value;

			// Reset future terms
			newTerms[idx].endDate = "";
			newTerms.forEach((nt, indx) => {
				if (indx > idx) {
					nt.startDate = "";
					nt.endDate = "";
				}
			});

			this.setState({ newTerms });
		} else if (name === "endDate") {
			newTerms[idx].endDate = value;

			this.setState({ newTerms });
		} else {
			newTerms[idx][name] = value;
			this.setState({ newTerms });
		}
	};

	handleChangeForNewTermCheckBox = (e, idx, dayId) => {
		const newTerms = [...this.state.newTerms];
		newTerms[idx].selectedWeekDays.forEach((week, i) => {
			if (week.id === dayId) {
				week.checked = e.target.checked;
			}
		});
		this.setState({ newTerms });
	};

	addTermRow = (e) => {
		e.preventDefault();
		const newTerms = [...this.state.newTerms];
		newTerms.push({
			name: "",
			startDate: "",
			endDate: "",
			date_toggle: false,
			selectedWeekDays: JSON.parse(JSON.stringify([...this.state.weekDays])),
		});
		this.setState({ newTerms });
	};

	deleteTermRow = (e, idx) => {
		e.preventDefault();
		const newTerms = [...this.state.newTerms];
		newTerms.splice(idx, 1);
		if (newTerms.length < 1) {
			swal({
				title: "Oops",
				text: "Atleast one term is necessary",
				closeOnClickOutside: false,
				allowOutsideClick: false,
			});
			draggable();
		} else {
			this.setState({ newTerms });
		}
	};

	addTermModalFooter = () => {
		return (
			<div className="container-fluid">
				<div className="row">
					<div className="col text-right">
						<button
							type="button"
							className="tt-button tt-button-primary mr-3"
							onClick={(e) => this.submitTerms(e)}
						>
							Save
						</button>
						<button
							type="button"
							className="tt-button tt-button-primary"
							onClick={(e) => this.handleAddTerms(e, "close")}
						>
							Cancel
						</button>
					</div>
				</div>
			</div>
		);
	};

	submitTerms = (e) => {
		e.preventDefault();
		const newTerms = [...this.state.newTerms];
		const submitTerms = [];
		if (newTerms.length > 0) {
			for (const el of newTerms) {
				const weekdays = [];
				for (const wk of el.selectedWeekDays) {
					if (wk.checked === true) {
						weekdays.push({ id: wk.id });
					}
				}

				submitTerms.push({
					name: el.name,
					startDate: el.startDate,
					endDate: el.endDate,
					tempDatabaseName: this.state.selectedAcademicYear,
					educationLevelId: this.state.selectedEducationLevel.id,
					weekDays: weekdays,
				});
			}
		}

		if (
			submitTerms.every(
				(item) =>
					item.name !== "" &&
					item.startDate !== "" &&
					item.endDate !== "" &&
					item.weekDays.length > 0,
			)
		) {
			this.setState({ showSpinner: true }, function () {
				axiosPost(
					URL.insertEducationLevelDivision,
					submitTerms,
					(response) => {
						if (response.status === 200) {
							swal({
								title: "Success",
								text: "Education Level Divisions sucessfully inserted",
								closeOnClickOutside: false,
								allowOutsideClick: false,
							});
							this.setState({ showSpinner: false });
							draggable();
							this.getAcademicYears();
							this.handleAddTerms(e, "close");
						}
					},
					(error) => {
						this.setState({ showSpinner: false });
						const errorResponse = error.response ? error.response.data : error;
						if (errorResponse.status === 400) {
							//if condition to check spring boot validation errors
							let errorMessage = "";
							if (errorResponse.errors) {
								for (const error of errorResponse.errors) {
									errorMessage += `${error.field
										.replace(/([A-Z])/g, " $1")
										.replace(/^./, (str) => {
											return str.toUpperCase();
										})} ${error.defaultMessage} \n`;
								}

								swal(errorResponse.error, errorMessage, "");
							} else {
								swal(errorResponse.error, errorResponse.message, "");
							}
						} else {
							swal(
								errorResponse.error || "Network Error",
								errorResponse.message
									? errorResponse.message
									: "Could Not Connect To The Server.",
								"",
							);
						}
					},
				);
			});
		} else {
			swal("Oops", "Fill all the required fields");
		}
	};

	render() {
		return (
			<>
				<div className="tt-widgetContent-tab-holder" id="academicYears">
					<div className="tt-group-header">
						List
						{checkWidgetAdminOrNot("Academic Administration") === true ? (
							<button
								type="button"
								className="tt-button tt-button-primary float-right permissionBtnCSS"
								onClick={() => {
									this.setState({
										permissionModal: !this.state.permissionModal,
									});
								}}
							>
								Permissions
							</button>
						) : null}
					</div>
					<div className="tt-newListBox">
						{this.state.academicYearsList.length > 0 ? (
							this.state.academicYearsList.sort((a, b) => Number(b.isCurrent) - Number(a.isCurrent)).map((academicYear, idx) => {
								return (
									<div key={academicYear.id} className="container-fluid mb-1">
										<div className="row tt-group-header">
											<div className="col-md-8">
												Academic Year : {academicYear.name}
											</div>
											<div className="col-md-3" />
											<div className="col-md-1">
												<span
													onClick={(e) => {
														this.toggleCollpasible(e, academicYear.id, idx);
														this.scrollToTop();
													}}
													onKeyDown={(e) => {
														this.toggleCollpasible(e, academicYear.id, idx);
														this.scrollToTop();
													}}
													style={{
														fontSize: "25px",
														position: "absolute",
														top: "-7px",
														right: "10px",
													}}
												>
													<FontAwesomeIcon
														icon={academicYear.isOpen ? faAngleUp : faAngleDown}
													/>
												</span>
											</div>
										</div>

										<CustomCollapse
											isOpen={academicYear.isOpen}
											collapsibleBody={
												<div className="container-fluid" id="collAcademicYear">
													{/* biome-ignore lint/suspicious/noArrayIndexKey: <explanation> */}
													<div className="row tt-background" key={idx}>
														<div className="col-md-2">
															<strong>{academicYear.name}</strong>
															{academicYear.isCurrent ? (
																<div className="tt-bubble-background">
																	<div>Current</div>
																</div>
															) : null}
														</div>
														<div className="col">
															{academicYear?.educationLevels && (
																<Semester
																	academicYear={academicYear}
																	termAlias={this.state.termAlias}
																	handleAddTerms={this.handleAddTerms}
																	educationLevels={academicYear.educationLevels}
																	mainIndex={idx}
																	handleUpdate={this.handleUpdate}
																	handleChange={this.handleChange}
																	updatedName={this.state.updatedName}
																	updatedStartDate={this.state.updatedStartDate}
																	updatedEndDate={this.state.updatedEndDate}
																	weekDays={this.state.weekDays}
																	handleChangeForCheckBox={
																		this.handleChangeForCheckBox
																	}
																	handleCancelEdit={this.handleCancelEdit}
																	handleDelete={this.handleDelete}
																	academicYearId={academicYear.id}
																	academicYearIndex={idx}
																	handleUpdateEducationLevelDivision={
																		this.handleUpdateEducationLevelDivision
																	}
																/>
															)}
														</div>
														<div
															className="col-md-auto"
															style={{ marginRight: "10px" }}
														>
															{/* {academicYear.isCurrent ? null : (
                                <div className="row mt-2">
                                  <button
                                    className="tt-button tt-button-primary tt-button-fullWidth"
                                    onClick={(e) =>
                                      this.handleCurrentChange(
                                        e,
                                        academicYear.id,
                                        idx
                                      )
                                    }
                                  >
                                    Set current
                                  </button>
                                </div>
                              )} */}
															<div className="row mt-2">
																{checkRolePermissions(
																	"disable-academic-year",
																	"activity",
																) ? (
																	<button
																		type="button"
																		className="tt-button tt-button-primary tt-button-fullWidth"
																		onClick={(e) =>
																			this.handleEnabledClick(
																				e,
																				academicYear.id,
																				idx,
																				!academicYear.isEnabled,
																			)
																		}
																		disabled={
																			!!(
																				academicYear.isCurrent &&
																				academicYear.isEnabled
																			)
																		}
																	>
																		{academicYear.isEnabled
																			? "Disable"
																			: "Enable"}
																	</button>
																) : null}
															</div>
														</div>
													</div>
												</div>
											}
										/>
									</div>
								);
							})
						) : (
							<div className="text-center" style={{ marginTop: "200px" }}>
								<Spinner color="primary" />
							</div>
						)}
					</div>
				</div>
				<ModalWindow
					modal={this.state.permissionModal}
					size="lg"
					id="tt-permissionModal"
					toggleModal={() => {
						this.setState({
							permissionModal: !this.state.permissionModal,
						});
					}}
					modalHeader={"Assign permission to user"}
					modalBody={
						<GranularPermissionModal
							widgetName="Academic Administration"
							moduleName="Academic Years"
							header="List Academic Years"
							activityName="select-academic-years"
						/>
					}
				/>
				<ModalWindow
					modal={this.state.addTermModal}
					size="lg"
					toggleModal={this.handleAddTerms}
					modalHeader="Add Terms"
					// modalClass="position-relative"
					modalBody={
						<AddTermsModal
							termAlias={this.state.termAlias}
							weekDays={this.state.weekDays}
							newTerms={this.state.newTerms}
							addTermRow={this.addTermRow}
							deleteTermRow={this.deleteTermRow}
							handleTermDataChange={this.handleTermDataChange}
							minStartDate={this.state.minStartDate}
							maxEndDate={this.state.maxEndDate}
							handleChangeForNewTermCheckBox={
								this.handleChangeForNewTermCheckBox
							}
							showSpinner={this.state.showSpinner}
						/>
					}
					modalFooter={this.addTermModalFooter()}
				/>
			</>
		);
	}
}

const mapStateToProps = (state, props) => ({
	academicYears: state.academicAdministration.academicYears,
});

const mapActionsToProps = {
	getAcademicYears: getAcademicYears,
};

export default connect(mapStateToProps, mapActionsToProps)(AcademicYearsList);
